"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createError = void 0;
var projectInfo_1 = require("./projectInfo");
var manipulateStackTrace_1 = require("./manipulateStackTrace");
function createError(errMsg) {
    var errMsgLine = "";
    var projectName = projectInfo_1.getProjectInfo().projectName;
    if (projectName) {
        errMsgLine += "[" + projectName + "]";
    }
    errMsgLine += errMsg;
    var err;
    {
        var stackTraceLimit__original = Error.stackTraceLimit;
        Error.stackTraceLimit = Infinity;
        err = new Error(errMsgLine);
        Error.stackTraceLimit = stackTraceLimit__original;
    }
    manipulateStackTrace_1.cleanStackTrace(err);
    if (err.message.includes("\n")) {
        throw new Error("Following assertion error message contains the new line `\n` character which is prohibited: " +
            err.message);
    }
    return err;
}
exports.createError = createError;
//# sourceMappingURL=createError.js.map